export enum ApiStrings {
  BaseUrl = "https://us-central1-helpocode19.cloudfunctions.net",
  ChallengesSlag = "/challenges",
  ThemesSlag = "/themes",
  PageQuery = "page=",
}
